module.exports = __webpack_public_path__ + "static/img/jinjing.e7bd274.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/people/jinjing.jpg
// module id = +ijp
// module chunks = 2